<template lang="pug">
.position-relative
  .navigation
    .position-back
      .button.is-small(
        @click="$emit('prev')"
      )
        span.icon.is-small
          i.fa.fa-arrow-left
        span Previous step
  .step-title
    span Your wallet address

  .features.address-info
    .field.field-address.has-addons
      .control.is-medium.is-expanded
        input.input.is-medium#address_input(
          type="text" 
          :placeholder="'Your ' + coin.symbol + ' address'"
          v-model="address"
          @keyup.enter="select"
        )
      .control#find_address
        a.button.is-medium(@click="select", :disabled="hasErrors", :class="{'is-success': !hasErrors}")
          span Next

    p.help.help-small.notif-danger(v-if="errorAddressMessage") 
      span(v-html="errorAddressMessage")

    p.help.help-small.notif-info(v-if="compatibleNetworks.length > 0 && (coin.chains.length > 1 || coin.chains[0].network !== coin.symbol)")
      span Your address is compatible with the 
      b(v-for="(o, index) in compatibleNetworks")
        span {{ o }}
        span(v-if="index < compatibleNetworks.length - 2") , 
        span(v-if="index === compatibleNetworks.length - 2")  and 
      span  network(s). 
      span(v-if="compatibleNetworks.length > 1") You may later switch payment networks.

    p.help.help-small.notification.is-warning.is-light(v-if="coin && coin.symbol === 'XRP'")
      span If you’ve just generated your XRP address in your wallet, ensure it is activated by transferring at least 1 XRP to it before your first mining payout.

    p.help.help-small.notification.is-warning.is-light(v-if="coin && coin.regex_memo")
      span If you are mining to an exchange
      span  you must set your Memo or Payment Tag after your address, like this: 
      strong.bg-warning.text-white-on-dark YOUR_ADDRESS:YOUR_PAYMENT_TAG


  .feature-helvetica.step-explanation
    span This is where we will transfer your mining balance, you will also be able to track your progress by searching this address on the Address page.
    br
    br

    span If you do not have an address you can create one on a non-custodial wallet provider (recommended) or an exchange, here are some useful articles from our 
    router-link.info-link.mr-5(to="/support", target="_blank") Support Center:

    .articles
      router-link.article-mini(to="/support/article/how-to-create-a-metamask-wallet", target="_blank")
        .article-inner
          .article-title
            span  How to create a metamask wallet
          span.icon
            i.fa.fa-external-link
      router-link.article-mini(to="/support/article/how-to-create-a-trust-wallet-account", target="_blank")
        .article-inner
          .article-title
            span  How to create a Trust Wallet account
          span.icon
            i.fa.fa-external-link

    span Some tokens or coins are supported on multiple networks, which you can switch at any time before a payout:

    .articles
      router-link.article-mini(to="/support/article/what-is-multi-chain-support-and-how-to-use-it", target="_blank")
        .article-inner
          .article-title
            span  What is multi chain support and how to use it?
          span.icon
            i.fa.fa-external-link

</template>

<script>
export default {
  name: 'c_step_address',
  props: ['coin'],
  data() {
    return {
      address: '',
      errorAddressMessage: '',
      compatibleNetworks: []
    }
  },
  computed: {
    hasErrors() {
      let vm = this
      return vm.errorAddressMessage || !vm.address
    }
  },
  watch: {
    address: function (val) {
      var vm = this
      vm.validateAddress()
    }
  },
  mounted() {
    document.getElementById('step').scrollIntoView();
  },
  methods: {
    select() {
      let vm = this
      if (!vm.hasErrors) {
        vm.$emit('selected', vm.address)
      }
    },
    validateAddress() {
      var vm = this
      if (vm.address) {
        let error = false;

        let chains = []
        let chainsNetworkString = []
        vm.compatibleNetworks = []

        let i = 0
        for (i = vm.coin.chains.length - 1; i >= 0; i--) {
          if (vm.coin.chains[i].is_default) {
            chains.push(vm.coin.chains[i])
            chainsNetworkString.push(vm.coin.chains[i].network)
          }
        }

        for (i = 0; i < vm.coin.chains.length; i++) {
          if (!vm.coin.chains[i].is_default) {
            chains.push(vm.coin.chains[i])
            chainsNetworkString.push(vm.coin.chains[i].network)
          }
        }

        chainsNetworkString = chainsNetworkString.join(', ')
        let lastIndexOfComma = chainsNetworkString.lastIndexOf(',')
        if (lastIndexOfComma !== -1) chainsNetworkString = chainsNetworkString.substring(0, lastIndexOfComma) + ' or' + chainsNetworkString.substring(lastIndexOfComma + 1)

        let oneOk = false
        let wrongMessage = ''

        let address = ''
        let memo = ''

        if (vm.coin.address_prefix) address = vm.address;
        else {
          address = vm.address.split(':')[0];
          memo = vm.address.split(':')[1];
        }

        for (i = 0; i < chains.length; i++) {
          if (!(new RegExp(chains[i].regex)).test(address)) {
            wrongMessage = `<span>Double check your <b>${vm.coin.symbol}</b> address, it seems to be invalid! ${vm.coin.symbol !== chains[i].network ? `It must be a valid <b>${chainsNetworkString}</b> address, as that's the network(s) we support for this coin.</span>` : ''}`
          } else if (memo && !chains[i].regex_memo) {
            if (chains.length === 1) wrongMessage = `<span>${vm.coin.symbol} does not support the ADDRESS:MEMO format!</span>`
            else wrongMessage = `<span>This  ${vm.coin.symbol} address on ${chains[i].network} network does not support the ADDRESS:MEMO format!</span>`
          } else {
            vm.compatibleNetworks.push(chains[i].network)

            if (chains[i].regex_memo) {
              if (memo && !(new RegExp(chains[i].regex_memo)).test(memo)) {
                wrongMessage = `<span>Double check your memo value, it seems to be invalid!</span>`
                i = chains.length - 1
                continue
              }
            }
            oneOk = true
          }
        }

        if (!oneOk) {
          error = wrongMessage
        }

        if (error) {
          vm.errorAddressMessage = error
        } else {
          vm.errorAddressMessage = ''
        }
      } else vm.errorAddressMessage = ''
    }
  }
}
</script>

<style lang="stylus" scoped>
.address-info
  margin-bottom 30px
  max-width 100%
</style>



// WEBPACK FOOTER //
// c_step_address.vue?6a8aee1c